import { Skeleton } from '@mui/material';
import React from 'react';


const SkeletonGauge = props => (    
    <Skeleton variant="circular" style={props.style} width={props.width} height={props.height} />
)

export default SkeletonGauge;